import React from 'react';
import { connect } from 'react-redux';
import { loadCategoryGroup, unloadCategoryGroup } from './actions';
import { track } from 'shared/models/analytic';
import { isEqual } from 'shared/models/address';
import Spinner from 'react-spinkit';
import HeadTags from '../category/head';
import CategoryHeaderImage from '../category/headerImage';
import ProductGrid from '../ProductGrid';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import ProductsHeader from 'components/productsHeader';
import { pageContainer, textCenter } from 'scy/utils.mod.scss';
import { ExtraWideContainer } from 'scy/layouts';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

class CategoryGroup extends React.Component {
  componentDidMount() {
    const name = this.nameFromProps(this.props);
    if (name !== this.props.groupName) {
      this.loadCategoryGroup(name);
    }
  }

  componentDidUpdate(prevProps) {
    const prevName = this.nameFromProps(prevProps);
    const nextName = this.nameFromProps(this.props);
    const categoryGroupHasChanged = nextName !== prevName;
    const addressHasChanged = !isEqual(this.props.address, prevProps.address);
    const prevUser = prevProps.user || {};
    const nextUser = this.props.user || {};
    const userHasChanged = prevUser.objectId !== nextUser.objectId;

    if (categoryGroupHasChanged || addressHasChanged || userHasChanged) {
      this.loadCategoryGroup(nextName);
    }
  }

  componentWillUnmount() {
    this.props.unloadCategoryGroup();
  }

  loadCategoryGroup(name) {
    this.props.loadCategoryGroup(name).then(() => {
      this.track();
    });
  }

  nameFromProps(props) {
    return props.match.params.name || props.location.pathname.slice(1);
  }

  track() {
    var listId = this.props.title;
    this.props.categories.forEach(category => {
      track('Product List Viewed', {
        list_id: listId,
        category: category.name,
        products: category.products.map(item => ({ product_id: item.sku_id }))
      });
    });
  }

  render() {
    const categories = this.props.categories || [];

    return (
      <div className={pageContainer}>
        <HeadTags
          title={this.props.title}
          slug={this.props.match.url}
          description={
            categories.length === 1 && categories[0].description
              ? categories[0].description
              : null
          }
        />

        <CategoryHeaderImage
          loading={this.props.loading}
          category={{
            _id: this.props.title,
            title: this.props.title,
            subtitle: this.props.subtitle
          }}
          className={margin.bottom_sm}
        />

        {this.props.loading ? (
          <div
            className={`${padding.top_xl} ${padding.bottom_xl} ${
              margin.top_xl
            } ${margin.bottom_xl} ${textCenter}`}
          >
            <Spinner spinnerName="three-bounce" />
          </div>
        ) : (
          <ExtraWideContainer
            className={`${padding.tablet_left_lg} ${padding.tablet_right_lg}`}
          >
            {categories.map(({ category, products }) =>
              !products.length || !category ? null : (
                <div
                  key={category.tag || category.name}
                  className={`${padding.sm} ${padding.tablet_md}`}
                >
                  <ProductsHeader title={category.name} url={category.url} />
                  <ProductGrid
                    products={products}
                    className={styles.grid}
                    itemClassName={styles.gridItem}
                  />
                </div>
              )
            )}
          </ExtraWideContainer>
        )}

        <AsyncLeadCaptureModal />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.categoryGroup,
    address: state.address,
    user: state.login.user
  };
}

export default connect(
  mapStateToProps,
  {
    loadCategoryGroup,
    unloadCategoryGroup
  }
)(CategoryGroup);
